module.exports = __webpack_public_path__ + "files/1dc6c40873f89f36bee21a4b39e61151.png";